import CreateReportTemplateContainer from "./CreateReportTemplateContainer";
export default CreateReportTemplateContainer;
